import { useRef, useState } from "react";
import client from "../../api/client";

const COUNTER = {
  title_ar: "title_en", title_en: "title_ar",
  description_ar: "description_en", description_en: "description_ar",
};
const tr = async (text, target) =>
  text ? (await client.post("/ai/translate", { text, target, mode: "notice" })).data.text : "";

// ترجمة تلقائية للجانب الآخر (عربي↔إنجليزي) بعد توقّف الكتابة 0.9ث عبر Gemini.
export const useTaskTranslate = (setF) => {
  const [translating, setTranslating] = useState("");
  const timers = useRef({});
  const autofill = (key, value) => {
    const dest = COUNTER[key];
    if (!dest) return;
    const to = key.endsWith("_ar") ? "en" : "ar";
    clearTimeout(timers.current[key]);
    if (!value.trim()) return;
    timers.current[key] = setTimeout(async () => {
      setTranslating(dest);
      try {
        const out = await tr(value, to);
        if (out) setF((p) => ({ ...p, [dest]: out }));
      } catch {
        /* يمكن الكتابة يدوياً */
      } finally {
        setTranslating("");
      }
    }, 900);
  };
  return { translating, autofill };
};
